import { Component, ChangeDetectionStrategy, ChangeDetectorRef, Input, NgModule } from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { breakpointBelow, ResponsiveService, SharedDirectiveModule, B2CSharedResponsiveModule } from 'b2c-ui/core';
import { tap } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { EmptyStatusEmailIcon, EmptyStatusFbIcon, EmptyStatusInstaIcon, PageNotFoundIcon, PageMaintenanceIcon, B2cUiIconModule, B2CUiIconService } from 'b2c-ui-icon';

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-empty-status.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'b2c-ui/core';
import * as ɵngcc2 from 'ng-zorro-antd/grid';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from 'b2c-ui-icon';

const _c0 = function (a0, a1) { return { "pb-5": a0, "pb-2": a1 }; };
function B2CEmptyStatusComponent_h3_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h3", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(2, _c0, !ctx_r0.isMobile, ctx_r0.isMobile));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.description, " ");
} }
function B2CEmptyStatusComponent_ul_10_a_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 13);
    ɵngcc0.ɵɵelement(1, "b2c-ui-icon", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("link", ctx_r4.facebook);
} }
function B2CEmptyStatusComponent_ul_10_a_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 13);
    ɵngcc0.ɵɵelement(1, "b2c-ui-icon", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("link", ctx_r5.insta);
} }
function B2CEmptyStatusComponent_ul_10_a_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 13);
    ɵngcc0.ɵɵelement(1, "b2c-ui-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("link", ctx_r6.email);
} }
function B2CEmptyStatusComponent_ul_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 11);
    ɵngcc0.ɵɵelementStart(1, "li");
    ɵngcc0.ɵɵtemplate(2, B2CEmptyStatusComponent_ul_10_a_2_Template, 2, 1, "a", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "li");
    ɵngcc0.ɵɵtemplate(4, B2CEmptyStatusComponent_ul_10_a_4_Template, 2, 1, "a", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "li");
    ɵngcc0.ɵɵtemplate(6, B2CEmptyStatusComponent_ul_10_a_6_Template, 2, 1, "a", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.coerceBoolean(ctx_r1.facebook));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.coerceBoolean(ctx_r1.insta));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.coerceBoolean(ctx_r1.email));
} }
const _c1 = function (a0) { return { "isMobile": a0 }; };
function B2CEmptyStatusComponent_b2c_ui_icon_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "b2c-ui-icon", 17);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c1, ctx_r2.isMobile));
} }
function B2CEmptyStatusComponent_b2c_ui_icon_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "b2c-ui-icon", 18);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c1, ctx_r3.isMobile));
} }
const _c2 = [[["", "title", ""]], "*"];
const _c3 = function (a0) { return { "text-center": a0 }; };
const _c4 = function (a0) { return { "font-size": a0 }; };
const _c5 = function (a0) { return { "mb-3": a0 }; };
const _c6 = ["[title]", "*"];
class B2CEmptyStatusComponent {
    /**
     * @param {?} responsiveService
     * @param {?} cdRef
     */
    constructor(responsiveService, cdRef) {
        this.responsiveService = responsiveService;
        this.cdRef = cdRef;
        this.responsiveService
            .observeBoolean(breakpointBelow.sm)
            .pipe(tap((/**
         * @param {?} matched
         * @return {?}
         */
        (matched) => {
            this.isMobile = matched;
            this.cdRef.markForCheck();
        })))
            .subscribe();
    }
    /**
     * Set Facebook Icon Link
     * @param {?} value
     * @return {?}
     */
    set facebook(value) {
        this._facebook = this.completeLink(value);
    }
    /**
     * @return {?}
     */
    get facebook() {
        return this._facebook;
    }
    /**
     * Set Instagram Icon Link
     * @param {?} value
     * @return {?}
     */
    set insta(value) {
        this._insta = this.completeLink(value);
    }
    /**
     * @return {?}
     */
    get insta() {
        return this._insta;
    }
    /**
     * Set Email Icon Link
     * @param {?} value
     * @return {?}
     */
    set email(value) {
        this._email = this.completeLink(value);
    }
    /**
     * @return {?}
     */
    get email() {
        return this._email;
    }
    /**
     * Set Page Type `notFound | maintenance`
     * @param {?} value
     * @return {?}
     */
    set type(value) {
        this._type = value.toLocaleLowerCase();
    }
    /**
     * @ignore
     * @return {?}
     */
    get type() {
        return this._type;
    }
    /**
     * @ignore
     * @param {?} value
     * @return {?}
     */
    coerceBoolean(value) {
        return coerceBooleanProperty(value);
    }
    /**
     * @private
     * @param {?} link
     * @return {?}
     */
    completeLink(link) {
        /** @type {?} */
        const regex = new RegExp('(http://)|(https://)', 'gmi');
        return regex.test(link) ? link : `https://${link}`;
    }
}
B2CEmptyStatusComponent.ɵfac = function B2CEmptyStatusComponent_Factory(t) { return new (t || B2CEmptyStatusComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ResponsiveService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
B2CEmptyStatusComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: B2CEmptyStatusComponent, selectors: [["b2c-empty-status"]], inputs: { isMobile: "isMobile", facebook: "facebook", insta: "insta", email: "email", type: "type", title: "title", description: "description", contentTitle: "contentTitle" }, ngContentSelectors: _c6, decls: 14, vars: 18, consts: [[1, "pt-5"], ["nz-row", "", "nzAlign", "middle", "nzJustify", "center"], ["nz-col", "", 3, "ngClass", "nzSpan"], [1, "font-weight-bold", "text-black-7", "pt-3", 3, "ngStyle", "ngClass"], ["class", "pt-2 mb-0 text-black-7", 3, "ngClass", 4, "ngIf"], [1, "font-size-md", "text-black"], ["class", "b2c-empty-status-icon pt-3", 4, "ngIf"], ["nz-col", "", 3, "nzSpan", "nzPull"], ["name", "pageNotFoundIcon", 3, "ngClass", 4, "ngIf"], ["name", "pageMaintenanceIcon", 3, "ngClass", 4, "ngIf"], [1, "pt-2", "mb-0", "text-black-7", 3, "ngClass"], [1, "b2c-empty-status-icon", "pt-3"], ["external", "", 3, "link", 4, "ngIf"], ["external", "", 3, "link"], ["name", "emptyStatusFbIcon", 1, "fb"], ["name", "emptyStatusInstaIcon", 1, "ig"], ["name", "emptyStatusEmailIcon", 1, "mail"], ["name", "pageNotFoundIcon", 3, "ngClass"], ["name", "pageMaintenanceIcon", 3, "ngClass"]], template: function B2CEmptyStatusComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c2);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, B2CEmptyStatusComponent_h3_5_Template, 2, 5, "h3", 4);
        ɵngcc0.ɵɵelementStart(6, "div", 5);
        ɵngcc0.ɵɵprojection(7);
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(9, 1);
        ɵngcc0.ɵɵtemplate(10, B2CEmptyStatusComponent_ul_10_Template, 7, 3, "ul", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 7);
        ɵngcc0.ɵɵtemplate(12, B2CEmptyStatusComponent_b2c_ui_icon_12_Template, 1, 3, "b2c-ui-icon", 8);
        ɵngcc0.ɵɵtemplate(13, B2CEmptyStatusComponent_b2c_ui_icon_13_Template, 1, 3, "b2c-ui-icon", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(12, _c3, ctx.isMobile))("nzSpan", ctx.isMobile ? 24 : 12);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(14, _c4, ctx.isMobile ? "55px" : "72px"))("ngClass", ɵngcc0.ɵɵpureFunction1(16, _c5, !ctx.description));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.title, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.description);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.contentTitle, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isMobile);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("nzSpan", ctx.isMobile ? 24 : 8)("nzPull", ctx._type == "notfound" ? ctx.isMobile ? 0 : 5 : 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx._type == "notfound");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx._type == "maintenance");
    } }, directives: [ɵngcc2.NzRowDirective, ɵngcc2.NzColDirective, ɵngcc3.NgClass, ɵngcc3.NgStyle, ɵngcc3.NgIf, ɵngcc1.ExternalLinkDirective, ɵngcc4.B2CUiIconComponent], encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
B2CEmptyStatusComponent.ctorParameters = () => [
    { type: ResponsiveService },
    { type: ChangeDetectorRef }
];
B2CEmptyStatusComponent.propDecorators = {
    facebook: [{ type: Input }],
    insta: [{ type: Input }],
    email: [{ type: Input }],
    title: [{ type: Input }],
    description: [{ type: Input }],
    contentTitle: [{ type: Input }],
    type: [{ type: Input }],
    isMobile: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CEmptyStatusComponent, [{
        type: Component,
        args: [{
                selector: 'b2c-empty-status',
                template: "<div class=\"pt-5\">\r\n  <div nz-row nzAlign=\"middle\" nzJustify=\"center\">\r\n    <div nz-col [ngClass]=\"{'text-center': isMobile}\" [nzSpan]=\"isMobile ? 24 : 12\">\r\n      <div class=\"font-weight-bold text-black-7 pt-3\" [ngStyle]=\"{'font-size': isMobile ? '55px' : '72px' }\" [ngClass]=\"{'mb-3': !description }\">\r\n        {{ title }}\r\n      </div>\r\n      <h3 *ngIf=\"description\" class=\"pt-2 mb-0 text-black-7\" [ngClass]=\"{'pb-5': !isMobile, 'pb-2': isMobile }\">\r\n        {{ description }}\r\n      </h3>\r\n      <div class=\"font-size-md text-black\">\r\n        <ng-content select=\"[title]\"></ng-content>\r\n        {{ contentTitle }}\r\n      </div>\r\n      <ng-content></ng-content>\r\n      <ul class=\"b2c-empty-status-icon pt-3\" *ngIf=\"!isMobile\">\r\n        <li>\r\n          <a external [link]=\"facebook\" *ngIf=\"coerceBoolean(facebook)\">\r\n            <b2c-ui-icon name=\"emptyStatusFbIcon\" class=\"fb\"></b2c-ui-icon>\r\n          </a>\r\n        </li>\r\n        <li>\r\n          <a external [link]=\"insta\" *ngIf=\"coerceBoolean(insta)\">\r\n            <b2c-ui-icon name=\"emptyStatusInstaIcon\" class=\"ig\"></b2c-ui-icon>\r\n          </a>\r\n        </li>\r\n        <li>\r\n          <a external [link]=\"email\" *ngIf=\"coerceBoolean(email)\">\r\n            <b2c-ui-icon name=\"emptyStatusEmailIcon\" class=\"mail\"></b2c-ui-icon>\r\n          </a>\r\n        </li>\r\n      </ul>\r\n    </div>\r\n    <div nz-col [nzSpan]=\"isMobile ? 24 : 8\" [nzPull]=\"( _type == 'notfound') ? (isMobile ? 0: 5) : 0\">\r\n        <b2c-ui-icon *ngIf=\"_type == 'notfound'\" name=\"pageNotFoundIcon\" [ngClass]=\"{'isMobile': isMobile}\"></b2c-ui-icon>\r\n        <b2c-ui-icon *ngIf=\"_type == 'maintenance'\" name=\"pageMaintenanceIcon\" [ngClass]=\"{'isMobile': isMobile}\"></b2c-ui-icon>\r\n    </div>\r\n  </div>\r\n</div>",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc1.ResponsiveService }, { type: ɵngcc0.ChangeDetectorRef }]; }, { isMobile: [{
            type: Input
        }], facebook: [{
            type: Input
        }], insta: [{
            type: Input
        }], email: [{
            type: Input
        }], type: [{
            type: Input
        }], title: [{
            type: Input
        }], description: [{
            type: Input
        }], contentTitle: [{
            type: Input
        }] }); })();
if (false) {
    /**
     * @ignore
     * @type {?}
     * @private
     */
    B2CEmptyStatusComponent.prototype._type;
    /**
     * @ignore
     * @type {?}
     * @private
     */
    B2CEmptyStatusComponent.prototype._facebook;
    /**
     * @ignore
     * @type {?}
     * @private
     */
    B2CEmptyStatusComponent.prototype._insta;
    /**
     * @ignore
     * @type {?}
     * @private
     */
    B2CEmptyStatusComponent.prototype._email;
    /**
     * Set The Page Title
     * @type {?}
     */
    B2CEmptyStatusComponent.prototype.title;
    /**
     * Set The Page Description
     * @type {?}
     */
    B2CEmptyStatusComponent.prototype.description;
    /**
     * Set The Content Title
     * @type {?}
     */
    B2CEmptyStatusComponent.prototype.contentTitle;
    /**
     * Set Mobile View
     * @type {?}
     */
    B2CEmptyStatusComponent.prototype.isMobile;
    /**
     * @type {?}
     * @private
     */
    B2CEmptyStatusComponent.prototype.responsiveService;
    /**
     * @type {?}
     * @private
     */
    B2CEmptyStatusComponent.prototype.cdRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-empty-status.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const ICONS = [
    EmptyStatusEmailIcon,
    EmptyStatusFbIcon,
    EmptyStatusInstaIcon,
    PageNotFoundIcon,
    PageMaintenanceIcon
];
class B2CEmptyStatusModule {
    /**
     * @param {?} b2cIconService
     */
    constructor(b2cIconService) {
        this.b2cIconService = b2cIconService;
        this.b2cIconService.registerIcons([...ICONS]);
    }
}
B2CEmptyStatusModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: B2CEmptyStatusModule });
B2CEmptyStatusModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function B2CEmptyStatusModule_Factory(t) { return new (t || B2CEmptyStatusModule)(ɵngcc0.ɵɵinject(ɵngcc4.B2CUiIconService)); }, imports: [[
            CommonModule,
            NzGridModule,
            SharedDirectiveModule,
            B2CSharedResponsiveModule,
            B2cUiIconModule
        ]] });
/** @nocollapse */
B2CEmptyStatusModule.ctorParameters = () => [
    { type: B2CUiIconService }
];
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(B2CEmptyStatusModule, { declarations: function () { return [B2CEmptyStatusComponent]; }, imports: function () { return [CommonModule,
        NzGridModule,
        SharedDirectiveModule,
        B2CSharedResponsiveModule,
        B2cUiIconModule]; }, exports: function () { return [B2CEmptyStatusComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CEmptyStatusModule, [{
        type: NgModule,
        args: [{
                declarations: [B2CEmptyStatusComponent],
                imports: [
                    CommonModule,
                    NzGridModule,
                    SharedDirectiveModule,
                    B2CSharedResponsiveModule,
                    B2cUiIconModule
                ],
                exports: [B2CEmptyStatusComponent]
            }]
    }], function () { return [{ type: ɵngcc4.B2CUiIconService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    B2CEmptyStatusModule.prototype.b2cIconService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-ui-empty-status.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { B2CEmptyStatusComponent, B2CEmptyStatusModule };


//# sourceMappingURL=b2c-ui-empty-status.js.map